export default {
    // OfferOne - form fields
    internal_name_hint:        "Interní název nabídky slouží jen pro tebe. Najdeš ho v seznamu nabídek.",
    internal_name_placeholder: "Interní název nabídky",
    internal_name_label:       "Interní název nabídky",
    title_hint:                'Nadpis cenové nabídky se zobrazí jako hlavní nadpis v tvé cenové nabídce. Pokud ho nevyplníš, zobrazí se nadpis "Cenová nabídka"',
    client_name_placeholder:   "Název klienta",
    client_name_label:         "Název klienta",
    no_client_found:           "Nenalezen žádný klient.",
    add_client_prefix:         '+ Přidat klienta s názvem',
    client_data_hint:          "Údaje klienta se zobrazí v horní části napravo. Údaje jsou rozděleny do dvou sloupců. Nalevo doporučujeme využít jméno klienta, adresu a napravo například IČO, DIČ, web. Pole jsou nepovinná.",
    client_left_placeholder:   "Údaje klienta (levý sloupec)",
    client_left_label:         "Údaje klienta (levý sloupec)",
    client_right_placeholder:  "Údaje klienta (pravý sloupec)",
    client_right_label:        "Údaje klienta (pravý sloupec)",
    cover_text_hint:           "Průvodní text je první text, který uvidí tvůj potenciální klient. Dej si záležet!",
    cover_text_placeholder:    "Průvodní text",
    cover_text_label:          "Průvodní text",

    // Buttons & actions
    save:          "Uložit",
    save_continue: "Uložit a pokračovat",
    save_finish:   "Uložit a dokončit",
    back:          "Zpět",
    create:        "Vytvořit nabídku",

    // Toast messages
    saved_msg:   "Informace byly uloženy.",
    updated_msg: "Cenová nabídka byla aktualizována.",
    url_copied:  "URL adresa byla zkopírována.",

    // Default values (used in data())
    default_title: "Cenová nabídka",

    // Client auto-fill labels
    ico:   "IČO: ",
    dic:   "DIČ: ",
    icdph: "IČ DPH: ",

    // OfferThree / OfferMain
    design_title: "Vzhled cenové nabídky",
    preview:      "Náhled cenové nabídky",
    step_basic:   "Základní nastavení",
    step_items:   "Tvorba položek a podpoložek",
    step_design:  "Vzhled cenové nabídky",

    // OfferRowButtons - actions
    send_mark_unsent:     "Označit jako neodesláno",
    send_mark_sent:       "Označit jako odesláno",
    send_tooltip_sent:    "Označit jako odesláno klientovi",
    send_tooltip_unsent:  "Označit jako neodesláno klientovi",
    copy_url:             "zkopírovat URL",
    copy_url_tooltip:     "Zkopírovat URL do schránky",
    open_offer:           "otevřít nabídku",
    open_offer_tooltip:   "Otevřít nabídku v novém tabu",
    edit_offer:           "Upravit nabídku",
    edit_offer_tooltip:   "Upravit nabídku",
    download_pdf:         "stáhnout PDF",
    download_pdf_tooltip: "Pro stažení PDF prosím nejprve zveřejni nabídku.",
    manage_items_tooltip: "Spravovat položky",
    duplicate_tooltip:    "Duplikovat nabídku",
    history_tooltip:      "Historie a poznámky",
    delete_tooltip:       "Smazat nabídku",
    deactivate:           "Deaktivovat nabídku",
    activate:             "Aktivovat nabídku",

    // Delete confirm dialog
    delete_confirm_title: "Jste si jistí?",
    delete_confirm_text:  "Opravdu chceš smazat nabídku?",
    delete_confirm_btn:   "Ano",

    // SendOffer
    send_email_sent_on:     "E-mail odeslán dne ",
    send_tooltip:           "Odeslat nabídku e-mailem",
    send_title:             "Odeslat nabídku e-mailem",
    send_sender_ph:         "Odesílatel",
    send_sender_label:      "Odesílatel",
    send_to_ph:             "E-mail příjemce",
    send_to_label:          "E-mail příjemce",
    send_cc_checkbox:       "Odeslat kopii",
    send_cc_ph:             "E-mail příjemce kopie",
    send_cc_label:          "E-mail příjemce kopie",
    send_message_ph:        "Zpráva",
    send_message_label:     "Zpráva",
    send_btn:               "Odeslat e-mail",
    send_history_title:     "Historie odesílání",
    send_date_col:          "Datum a čas",
    send_email_col:         "E-mail příjemce",
    send_cc_prefix:         "Kopie:",
    send_attachments_title: "PŘÍLOHY",
    send_upload_feedback:   "Vlož <b data-click='no'>přílohu</b> přetažením nebo <span class='nahraj' data-click='no'>nahraj přílohu</span>",

    // OfferTitleFoto + EntryTitlePhoto (shared)
    title_photo_title:       "Titulní fotka",
    title_photo_hint:        "Nahraj titulní fotku nabídky. Ta se zobrazí jako pozadí v záhlaví. Pokud nebude nahrána, zobrazí se výchozí pozadí s veřejným názvem nabídky.",
    hide_name_desktop:       "Skrýt název na titulní fotce (desktop)",
    hide_name_desktop_hint:  "Když je zapnuto, název nabídky se nezobrazí na titulní fotce. Hodí se, pokud máte vlastní fotku s",
    hide_name_mobile:        "Skrýt název na titulní fotce (mobil)",
    uploading:               "Nahrávání...",
    upload_img_feedback:     "Vlož <b>obrázek</b> přetažením nebo <span class='nahraj'>nahraj obrázek</span>",
    img_remove:              "Smazat",
    img_download:            "Stáhnout",
    img_remove_confirm:      "Opravdu chcete smazat obrázek?",
    img_only_one:            "Je možné nahrát jen 1 obrázek. Prosím, nejprve smažte původní.",
    img_invalid_type:        "Obrázek tohoto typu nemůže být nahrán.",
    img_too_large_suffix:    " je příliš velký! Prosím, vyberte obrázek do velikosti ",
    title_photo_mobile_label:  "Titulní fotka mobil",
    title_photo_desktop_label: "Titulní fotka",

    // Entry
    entry_move_up:       "Posunout položku výš",
    entry_duplicate:     "Duplikovat položku",
    entry_move_down:     "Posunout položku níž",
    entry_name_ph:       "Název položky",
    entry_name_label:    "Název položky",
    entry_items_db:      "Databáze položek",
    entry_history:       "Historie položek",
    entry_add_desc:      "Přidat popis položky",
    entry_count_from:    "počet od",
    entry_count:         "počet",
    entry_count_to:      "počet do",
    entry_discount:      "Sleva",
    entry_price_vat:     "Vlastní cena bez DPH",
    entry_price:         "Vlastní cena",
    entry_exclude:       "Nezahrnout",
    entry_include:       "Zahrnout",
    entry_in_total:      "položku do celkové ceny",
    entry_excluded_msg:  "Tato položka nebude zahrnuta do celkové ceny",
    entry_included_msg:  "Tato položka bude zahrnuta do celkové ceny",
    entry_expand_sub:    "Rozbalit podpoložky",
    entry_collapse_sub:  "Sbalit podpoložky",
    entry_add_sub:       "Přidat podpoložku",
    entry_add_images:    "Přidat obrázky k položce",

    // OfferRow
    row_active_tooltip:   "Nabídka je aktivní a veřejná",
    row_inactive_tooltip: "Nabídka je neaktivní a neveřejná",
    row_no_client:        "Potřeba přiřadit klienta",
    row_updated:          "aktualizováno",
    row_created:          "vytvořeno",
    row_opened:           "x otevřeno",
    row_reset:            "resetovat",
    row_accepted:         "přijato",
    row_rejected:         "odmítnuto",
    row_status_accepted:  "označena jako akceptovaná. Kliknutím zrušíš tento stav.",
    row_status_rejected:  "označena jako odmítnutá. Kliknutím zrušíš tento stav.",
    row_status_prefix:    "Tato nabídka byla",
    row_status_changed:   "Stav nabídky byl úspěšně změněn",
    row_reset_title:      "Jsi si jistý?",
    row_reset_text:       "Opravdu chceš zrušit stav nabídky?",
    row_reset_btn:        "Ano",
    row_status_removed:   "Stav nabídky byl odstraněn.",
    row_send_unsent:      "Nabídka byla nastavena jako neodeslána.",
    row_send_sent:        "Nabídka byla nastavena jako odeslána.",

    // OffersTable
    table_title:        "Moje cenové nabídky",
    table_header:       "Cenové nabídky",
    clear_filter:       "Vymazat filtr",
    search_placeholder: "ID, NÁZEV NABÍDKY, KLIENTA",
    searching:          "Vyhledávám nabídky…",
    not_found:          "Nenalezeny žádné nabídky…",
    empty_msg:          "Aktuálně nemáš vytvořeny žádné cenové nabídky. Nechceš nějakou vytvořit?",
    load_more:          "Načíst další nabídky",

    // SubEntry
    subentry_name_ph:       "Název položky",
    subentry_name_label:    "Název podpoložky",
    subentry_excluded_msg:  "Tato podpoložka nebude zahrnuta do celkové ceny tvé nabídky.",
    subentry_included_msg:  "Tato podpoložka bude zahrnuta do celkové ceny tvé nabídky.",
    subentry_hourly:        "Cena za hodinovou sazbu",

    // Entry/SubEntry action toolbar
    entry_delete:           "Smazat položku",
    entry_delete_msg:       "Položka se natrvalo odstraní z této nabídky.",
    entry_save_item:        "Uložit do Položek a cen",
    entry_update_item:      "Aktualizovat uloženou položku",
    entry_save_msg:         "Ulož tuto položku do své databáze, abys ji mohl rychle použít v dalších nabídkách.",
    entry_update_msg:       "Tuto položku už máš uloženou v Položkách a cenách. Klikni pro aktualizaci na aktuální hodnoty.",
    subentry_delete:        "Smazat podpoložku",
    subentry_delete_msg:    "Podpoložka se natrvalo odstraní z této nabídky.",
    subentry_save_item:     "Uložit do Položek a cen",
    subentry_update_item:   "Aktualizovat uloženou položku",
    subentry_save_msg:      "Ulož tuto podpoložku do své databáze, abys ji mohl rychle použít v dalších nabídkách.",
    subentry_update_msg:    "Tuto podpoložku už máš uloženou v Položkách a cenách. Klikni pro aktualizaci na aktuální hodnoty.",

    // OfferLegend
    legend_hide:            "Skrýt legendu",
    legend_show:            "Zobrazit legendu",
    legend_video:           "Podívat se na video návod",
    legend_client_right:    "Údaje tvého klienta (pravý sloupec)",
    legend_client_left:     "Údaje tvého klienta (levý sloupec)",
    legend_title:           "Veřejný nadpis nabídky",
    legend_cover_text:      "Průvodní text",
    legend_summary:         "Souhrnná čísla",
    legend_item:            "Položka",
    legend_item_discount:   "Položka se slevou",
    legend_subitem:         "Podpoložka",

    // OstatneNastavenia
    other_id_ph:            "Interní ID nabídky",
    other_id_label:         "Interní ID nabídky",
    other_no_firms:         "Aktuálně nemáš přidány žádné firmy.",
    other_more_firms:       "Máš více firem?",
    other_issue_date:       "Datum vystavení nabídky",
    other_valid_date:       "Datum platnosti nabídky",
    other_en_upsell:        "Chceš mít <b>nabídku anglicky?</b>",

    // SablonaNaMieru
    template_title:         "Chceš vlastní unikátní šablonu?",
    template_desc:          "PREMIUM uživatelům nabízíme možnost tvorby šablony na míru. Dokážeš se tak úplně odlišit od ostatních.",
    template_cta:           "Mám zájem o šablonu na míru",
    template_modal_title:   "Vlastní šablona na míru",
    template_modal_desc:    "Chceš své cenové nabídky úplně odlišit od ostatních? Vypracujeme ti návrh šablony na míru. Stačí vyplnit pár informací a tvé představy. My se ti ozveme s nezávaznou nabídkou.",
    template_phone_ph:      "Telefonní číslo",
    template_phone_label:   "Telefonní číslo",

    // VzhladCenovejPonuky
    design_color_title:     "Barevná kombinace",
    design_later:           "Vzhled cenové nabídky můžeš změnit i později.",
    design_custom_color:    "Vlastní barva",
    design_compact_hint:    "Při zapnutí této možnosti bude design využívat menší mezery a menší písmo, aby byla nabídka kompaktnější",
    design_compact_label:   "Kompaktní verze designu",
    design_hide_logo_hint:  "Jako PREMIUM uživatel máš možnost skrýt naše",

    // OfferOneCheckboxes
    checkbox_accept_title:  "Možnost přijmout nebo odmítnout cenovou nabídku",
    checkbox_accept_hint:   "V případě, že zapneš tuto možnost, v nabídce se zobrazí možnost přijmout, nebo odmítnout tvou nabídku. Klient ti tak může přímo odpovědět pozitivně / negativně. Budeme tě o tom informovat mailem.",
    checkbox_delivery_cta:  "Přidat dobu dodání",
    checkbox_delivery_hint: "V případě, že zapneš tuto možnost, v nabídce se zobrazí sekce s dobou dodání. Můžeš zadat dobu dodání a",
    checkbox_reviews_title: "Zobrazit recenze klientů v nabídce",
    checkbox_reviews_hint:  'Aktivuj tuto možnost a na konci nabídky zobrazíme recenze tvých klientů, které si můžeš přidat v sekci "Recenze".',

    // OfferFiles
    files_hint:             "Nahraj dokumenty, které mají být k dispozici ke stažení.",
    files_premium_msg:      "Chceš přidat <b>soubory</b> k tvé nabídce? <a href='/admin/balicky'> Přejdi na PREMIUM.</a>",
    files_upload_feedback:  "Vlož <b>dokumenty</b> přetažením nebo <span class='nahraj'>nahraj dokumenty</span>",
    files_remove:           "Smazat",
    files_download:         "Stáhnout",
    files_remove_confirm:   "Opravdu chcete smazat dokument?",
    files_only_five:        "Je možné nahrát jen 5 dokumentů. Prosím, nejprve smažte původní.",
    files_invalid_type:     "Dokument tohoto typu nemůže být nahrán.",
    files_too_large_suffix: " je příliš velký! Prosím, vyberte dokument do velikosti ",

    // LoadSignature
    sig_label:              "razítko / Podpis",
    sig_edit_title:         "Upravit",
    sig_upload_feedback:    "Vlož <b>podpis</b> nebo <b>razítko</b> přetažením nebo <span class='nahraj'>nahraj podpis</span>",
    sig_remove:             "Smazat",
    sig_download:           "Stáhnout",
    sig_remove_confirm:     "Opravdu chcete smazat podpis?",

    // EntryImages
    images_label:           "FOTKY, OBRÁZKY",
    images_upload_feedback: "Vlož <b>obrázky</b> přetažením nebo <span class='nahraj'>nahraj obrázky</span>",
    images_remove:          "Smazat",
    images_download:        "Stáhnout",
    images_remove_confirm:  "Opravdu chcete smazat obrázek?",
    images_only_ten:        "Je možné nahrát jen 10 obrázků. Prosím, nejprve smaž původní.",
    images_invalid_type:    "Prosím nahrávej obrázky jen ve formátu ",
    images_too_large_suffix:" je příliš velký! Nahraj soubor do velikosti ",

    // MaxOfferModal
    modal_close:            "Zavřít",
    modal_manage_sub:       "Spravovat předplatné",
    modal_offers_counter:   "vytvořených nabídek",
    modal_offers_limit:     "Dosáhl jsi svůj limit nabídek",
    modal_offers_text:      "V balíčku ZDARMA můžeš vytvořit <br> <strong>maximálně 3 nabídky</strong>. Pokud chceš přidat <br> další, přejdi na vyšší balíček.",
    modal_clients_counter:  "vytvořených klientů",
    modal_clients_text:     "V balíčku ZDARMA můžeš vytvořit <br> <strong>maximálně 3 klienty</strong>. Pokud chceš přidat <br> dalšího, přejdi na vyšší balíček.",
    modal_accounts_counter: "využitých přístupů",
    modal_accounts_limit:   "Dosáhl jsi svůj limit účtů",

    // SendOffer remaining
    send_upload_drop:       "Vlož <b data-click='no'>přílohu</b> přetažením nebo <span class='nahraj' data-click='no'>nahraj přílohu</span>",
    send_file_remove:       "Smazat",
    send_file_download:     "Stáhnout",
    send_file_remove_confirm: "Opravdu chcete smazat přílohu?",
    send_email_subject:     "Cenová nabídka",

    // KontaktnaOsoba
    contact_title:       "Kontaktní osoba",
    contact_hint:        "Tento kontakt bude zveřejněn v nabídce.",
    contact_phone_ph:    "Telefonní číslo",
    contact_phone_label: "Telefonní číslo",
    contact_add_company: "Přidat firemní nebo jiné údaje do nabídky",
    contact_data_hint:   "Údaje, které zde vyplníš, se zobrazí v dolní části",
    contact_company_ph:  "FIREMNÍ nebo DOPLŇUJÍCÍ údaje v nabídce",
    contact_company_label: "FIREMNÍ nebo DOPLŇUJÍCÍ údaje v nabídce",

    // Entry - type names
    entry_type_hourly:    "Cena za hodinovou sazbu",
    entry_type_range:     "Cenový rozsah od - do",
    entry_type_hour_range:"Hodinový rozsah od - do",
    entry_type_custom:    "Vlastní cena",
    entry_type_subitems:  "Celková cena z podpoložek",
    entry_add_note:       "Přidat interní poznámku...",

    // OstatneNastavenia
    other_section_title:  "Ostatní nastavení",
    other_lang_sk:        "Slovenština",
    other_lang_cz:        "Čeština",
    other_lang_en:        "Angličtina",
    other_lang_de:        "Němčina",
    datepicker_months:    "Leden,Únor,Březen,Duben,Květen,Červen,Červenec,Srpen,Září,Říjen,Listopad,Prosinec",
    datepicker_months_short: "Led,Úno,Bře,Dub,Kvě,Čvn,Čvc,Srp,Zář,Říj,Lis,Pro",
    datepicker_weekdays:  "Neděle,Pondělí,Úterý,Středa,Čtvrtek,Pátek,Sobota",
    datepicker_weekdays_short: "Ne,Po,Út,St,Čt,Pá,So",

    // SubEntry remaining
    subentry_type_range:     "Cenový rozsah od - do",
    subentry_type_hour_range:"Hodinový rozsah od - do",
    subentry_type_custom:    "Vlastní cena",
    subentry_hours:          "hodin",

    // OfferLegend remaining
    legend_item_gallery:     "Položka s fotkou nebo galerií",
    legend_item_cover:       "Položka s titulní fotkou",
    legend_accept_option:    "Možnost přijmout nebo odmítnout nabídku",
    legend_pdf_option:       "Možnost stáhnout nabídku jako PDF",
    legend_total_price:      "Celková cena nabídky i se slevami",
    legend_company_data:     "Tvoje firemní údaje",
    legend_validity:         "Platnost nabídky",
    legend_logo:             "Logo DOFFERO, které je možné skrýt",
    legend_contact_person:   "Kontaktní osoba",

    // CreatedOfferAlert
    created_alert_published: "Cenová nabídka byla úspěšně zveřejněna",
    created_alert_url_label: "Cenová nabídka je dostupná online na URL:",
    created_alert_copy_link: "Zkopírovat odkaz",
    created_alert_view:      "Zobrazit nabídku",
    created_alert_pdf:       "Stáhnout PDF",
    created_alert_new:       "Vytvořit novou cenovou nabídku",
    created_alert_send:      "Odeslat nabídku emailem",

    // SumerneCisla
    summary_title:           "Zobrazení souhrnných čísel",
    summary_hint:            "Souhrnná čísla se zobrazí na vrchu cenové nabídky a obsahují název a výslednou cenu každého celku. Je možné přidat maximálně 4 čísla.",
    summary_toggle:          "Zobrazit souhrnná čísla",
    summary_name_ph:         "Název",
    summary_name_label:      "Název",
    summary_auto_total:      "Přidat automatický součet na konec",
    summary_auto_total_hint: "Pokud zaškrtneš tuto možnost, na konec řádku přidáme celkovou cenu tvé nabídky.",
    summary_add_more:        "+ Přidat další číslo",
    summary_count:           "ze 3 možných",

    // CompanyUsers
    companyusers_title:       "využitých přístupů",
    companyusers_delete_title:"Co s vytvořenými nabídkami?",
    companyusers_delete_text: "Při smazání je potřeba rozhodnout, co udělat s vytvořenými cenovými nabídkami pod účtem tohoto uživatele. Prosím, vyber zda chceš nabídky smazat, nebo je přesunout na svůj účet. Akce je nevratná.",
    companyusers_delete_btn:  "Smazat nabídky",
    companyusers_move_btn:    "Přesunout nabídky",
    companyusers_deleted_msg: "Uživatel byl smazán.",
    companyusers_moved_msg:   "Nabídky byly úspěšně přesunuty a uživatel smazán.",

    // FirstLogin remaining
    first_login_offer_url:   "Tvůj odkaz na cenovou nabídku bude vypadat takto:",
    first_login_prices:      "Nastavit ceny s",
    first_login_area_ph:     "OBLAST PODNIKÁNÍ",
    first_login_area_select: "Kliknutím vyberéš oblast",
    first_login_area_desel:  "Kliknutím odstraníš oblast",
    first_login_specify_ph:  "Umíš konkretizovat?",
    first_login_specify_label:"Umíš konkretizovat?",
    first_login_personal_note:"Tato informace slouží ke zlepšování a personalizaci našich služeb.",
    first_login_complete_btn: "Dokončit registraci",
    first_login_slug_taken:  "Takový odkaz již někdo používá. Zkus použít jiný.",
    first_login_no_firma:    "Prosím vyplň název firmy nebo značky.",

    // OfferTwo
    two_add_item:           "Přidat další položku",
    two_add_discount:       "Přidat celkovou slevu",
    two_hide_total:         "Nezobrazit celkovou cenu v nabídce",
    two_hide_total_hint:    "Při zvolení této možnosti v nabídce vůbec nezobrazíme celkovou cenu.",
    two_view_online:        "Zobrazit nabídku online",
    two_saving:             "Ukládá se...",
    two_autosaved_prefix:   "Automaticky uloženo ",
    two_saved_prefix:       "Uloženo ",
    price_total:            "Celková cena: ",
    price_total_vat:        "Celková cena s DPH: ",
    price_total_discount:   "Celková cena po slevě: ",
    price_total_vat_disc:   "Celková cena s DPH po slevě: ",
    price_discount_label:   "Sleva: ",
    price_no_vat_disc:      "Celková cena po slevě bez DPH: ",
    price_vat_with_disc:    "Celková cena po slevě s DPH: ",
    price_no_vat:           "Celková cena bez DPH: ",
    two_delete_title:       "Jste si jistí?",
    two_delete_text:        "Opravdu chceš smazat tuto položku?",
    two_delete_btn:         "Ano",

    // EntryImagesModal
    images_modal_title:    "Nahrajte fotky k položce",
    images_modal_add_btn:  "Přidat obrázky k položce",
    images_modal_hint:     "Přidej si obrázky k tvé položce. Maximální počet obrázků je 10, každý do velikosti 4 MB.",
    images_modal_cover:    "Přidat titulní fotku k položce",

    // FirstLoginAfter
    first_after_create_title: "Chci hned tvořit nabídku",
    first_after_create_desc:  "Pusť se hned do toho a zjisti, jak se vytváří cenová nabídka v DOFFERO.",
    first_after_create_btn:   "Nová cenová nabídka",
    first_after_setup_title:  "Chci si nastavit firemní a kontaktní informace",
    first_after_setup_desc:   "Nastav si údaje, které se týkají tvé firmy a budou se zobrazovat v tvých nabídkách. Tyto info můžeš kdykoliv změnit.",
    first_after_setup_btn:    "Nastavit údaje",
    first_after_help:         "Nevíš jak dál? Kontaktuj mě na",

    // AiDescriptionButton
    ai_btn_fill_name:   "Pro použití AI generování popisu vyplňte název položky",
    ai_btn_hint:        "AI vygeneruje profesionální popis na základě názvu, ale i průvodního textu nabídky. Čím konkrétnější je název položky nebo popis nabídky, tím lepší popis se vygeneruje.",
    ai_btn_label:       "Vygenerovat popis přes AI",

    // FilterSelect
    filter_my_users:    "Moji uživatelé",
    filter_find_ph:     "NAJÍT UŽIVATELE",
    filter_not_found:   "Uživatel nebyl nalezen.",

    // PaidModal
    paid_close:         "Zavřít",
    paid_check_payment: "Zkontrolovat platbu",
    paid_manage_sub:    "Spravovat předplatné",
    paid_feature_title: "Narazil jsi na placenou funkci",
    paid_feature_text:  "<strong>Tato funkce je placená</strong> a je součástí <br> vyššího balíčku, protože si myslíme, <br> že za to stojí a přinese ti velkou <br> hodnotu. :-)",
    paid_error_title:   "Nepodařilo se nám zpracovat tvoji platbu",
    paid_error_text:    "Automatická platba za tvoje předplatné neprošla. Důvodů může být několik - nedostatek prostředků, expirovaná karta nebo zablokovaná platba. Přejdi do platební brány a zaplať znovu.",

    // SuperFaktura
    sf_copy_tooltip:    "Zkopírovat nabídku do aplikace SuperFaktura.sk",
    sf_no_api_tooltip:  "Propojení na superfakturu - potřeba vyplnit API klíč v nastavení integrací.",
    sf_success_msg:     "Nabídka byla úspěšně zkopírována do aplikace SuperFaktura.sk.",
    sf_go_invoices:     "Přejít na faktury",

    // FirstLogin errors
    first_login_area_required: "Tato informace je povinná.",
    first_login_success: "Registrace byla úspěšně dokončena.",

    // SendOffer warnings/errors
    send_warning_five_files:    "Je možné nahrát jen 5 dokumentů. Prosím, nejprve smažte původní.",
    send_warning_too_large:     "Vybrané přílohy jsou příliš velké! Prosím, vyberte přílohy do velikosti ",
    send_warning_too_large_mb:  " MB.",
    send_warning_type:          "Příloha tohoto typu nemůže být nahrána.",
    send_warning_file_large:    " je příliš velký! Prosím, vyberte přílohu do velikosti ",
    send_warning_subject:       "Treba vyplnit předmět emailu.",
    send_warning_email:         "Treba vyplnit email příjemce.",
    send_warning_email_format:  "Email příjemce má špatný formát.",
    send_warning_message:       "Treba vyplnit zprávu.",
    send_success_sent:          "Email úspěšně odeslán.",

    // ThreeOffers
    three_can_create:        "Můžeš vytvořit ještě",
    three_limit_reached:     "Vyčerpal jsi své aktivní nabídky!",
    three_currently_active:  "Aktuálně máš aktivní",
    three_free_info:         "S DOFFERO FREE máš možnost",
    three_free_count:        "3 aktivních nabídek.",
    three_deactivate_hint:   "Potřebuješ jich více? Deaktivuj staré nabídky",

    // FiveKlients
    five_can_create:       "Můžeš vytvořit ještě",
    five_limit_reached:    "Vyčerpal jsi své klienty!",
    five_currently:        "Aktuálně máš vytvořených",
    five_free_info:        "S DOFFERO FREE máš možnost",
    five_free_count:       "přidat si 5 klientů.",
    five_deactivate_hint:  "Potřebuješ jich více? Smaž staré klienty nebo",

    // items.vue
    items_searching:       "Vyhledávám položky",
    items_not_found:       "Nenalezeny žádné položky…",
    items_load_more:       "Načíst další položky",

    // ActionCompanyUsers
    access_title:          "Přístupy",
    access_see_mine:       "Uživatel vidí nabídky vytvořené mnou (vlastníkem týmu)",
    access_see_team:       "Uživatel vidí nabídky vytvořené jinými členy týmu",

    // MainUcet
    save_template_btn:     "Uložit template",
    template_saved_msg:    "Template byl změněn.",
};